import { render, staticRenderFns } from "./leftItem01.vue?vue&type=template&id=063cbf54&scoped=true&"
import script from "./leftItem01.vue?vue&type=script&lang=js&"
export * from "./leftItem01.vue?vue&type=script&lang=js&"
import style0 from "./leftItem01.vue?vue&type=style&index=0&id=063cbf54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063cbf54",
  null
  
)

export default component.exports